module.exports = __webpack_public_path__ + "img/Jump Casting134.f7bcbaaa.jpg";